						 
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CollectionView } from '@grapecity/wijmo';
import { AccCategoryE, EPatient, OrganizationRequest, RxTransferE } from 'src/app/models';
import * as wjcGrid from "@grapecity/wijmo.grid"
import { Subject } from 'rxjs';
import { CommonUtil, WijimoUtil } from 'src/app/utils';
import * as moment from 'moment';
import { AlertService, CommonService, ErxService, ModalWrapperService, PatientService, UserService } from 'src/app/services';
import { takeUntil } from 'rxjs/operators';
import { MsgConfig } from 'src/app/app.messages';
import { StorageService } from 'src/app/services/storage.service';
import { CommonWarnorconfirmPopupComponent } from '../common-warnorconfirm-popup/common-warnorconfirm-popup.component';
import { DateCheckUtil } from 'src/app/utils/date-checks.util';
import { environment } from 'src/environments/environment';
import { PrivMaskGuard } from 'src/app/guards';
import { v4 as uuid } from 'uuid';

@Component({
selector: 'app-patient-external-history',
templateUrl: './patient-external-history.component.html',
styleUrls: ['./patient-external-history.component.scss'],
standalone: false
})
export class PatientExternalHistoryComponent implements OnInit {
@ViewChild("PATEXTERNALHIST", {static: true})
PATEXTERNALHIST: any;

@Input() patientFG : FormGroup;
@Input() patientId: number;
@Input() rxPatientModel : EPatient;
@Input() FrmEditPatient : boolean;

@Output() ClosePatHistModel = new EventEmitter<any>();
@Output() EmittoSaveExternalHist = new EventEmitter<any>();
@Output() AddorUpdateExternalHist = new EventEmitter<any>();
@Output() SendExternHistCount = new EventEmitter<any>();
isDataExists = false;
externalPatientWJ: CollectionView;
@ViewChild("externalPatient") externalPatient: wjcGrid.FlexGrid;
unsubscribe$: Subject<void> = new Subject();
wjHeaders: any;
modelRef: any;
userName: string;
openTrnsReqPopup: boolean;
selectedRxInfo : any;
iseditRecord: boolean;
id: any;
currentEditItem: any;
isItemAlreadyAdded: boolean;
today: string;
maxDate: { year: number; month: number; day: number; };
isFillDateMin: boolean;
drugInformation: any;
IsTransferRequestAllowd: boolean;
allowRxTransferIn =  {
    isPrivilege: false,
    serviceAvailability:  false
};
accessPrivCate: any;
tranferPrivs: any;
msgConfig : any
externalHistCount: any;
isSaveEnabled: boolean;
isPopupOpen: any;
closeAttentionPopup: boolean;
sourcePharmacyDetails: any;
sourcePharmacyID: any;
sourcePharmacyNPI: any;
popupId = uuid();
@HostListener("window:keydown", ["$event"])
keyEventAlt(event: KeyboardEvent) {
      const topPopup = this._commonUtil.getTopPopup();
      if (topPopup === this.popupId) {
          if (event.which === 27) {
              this.closePatHistModel();
              event.preventDefault();
          }
        }
    }
constructor(private _wijimoUtils: WijimoUtil, private _userService: UserService, private _commonUtil : CommonUtil,
private _alertSvc: AlertService, private _modalService: ModalWrapperService, private _dateUtil: DateCheckUtil,
private _patService : PatientService, private _commonSrv: CommonService, private _eRxService: ErxService,
private _cdr: ChangeDetectorRef,public _storageService: StorageService, private _privMaskGuard: PrivMaskGuard) {
  this.accessPrivCate = AccCategoryE;
  this.tranferPrivs = RxTransferE;
  this.msgConfig = MsgConfig;
}

ngOnInit(): void {
this._commonUtil.open(this.popupId);
this.allowRxTransferIn = {
  isPrivilege: this.checkHasPrivsToAccess(this.accessPrivCate.RxTransfer, this.tranferPrivs.AllowRxTransferIn),
  serviceAvailability: sessionStorage.getItem("ServiceAvailablity") ? JSON.parse(this._commonSrv.DecryptData(sessionStorage.getItem("ServiceAvailablity"))) : false
}
this.today = this._dateUtil.getCurrentDate();
this.maxDate = {
    year: moment(this.today).year(),
    month: moment(this.today).month() + 1,
    day: moment(this.today).date()
};
this.patchDefaultValHeaders();
this._wijimoUtils.wjSavedData$.subscribe(w => {
    if (w && w["WijmoKey"] && w["WijmoKey"] === "PatientExternalHistoryWJ") {
        this.patchDefaultValHeaders();
    }
});
this.IsTransferRequestAllowd = environment.TransferInRequest;
this.getPatientExternalHistory();
}

async patchDefaultValHeaders() {
const storedWJ = await this._wijimoUtils.getWJSavedData("PatientExternalHistoryWJ");
this.wjHeaders = this._wijimoUtils.patchDefHeader("PatientExternalHistoryWJ", storedWJ);
}

init(flex: wjcGrid.FlexGrid) {
flex.columnHeaders.rows[0].wordWrap = true;
flex.autoSizeRow(0, true);   
}

loadedWJRows(flex: wjcGrid.FlexGrid) {
flex.collapseGroupsToLevel(0);
}
checkHasPrivsToAccess(category: string, privType: string) {
return this._privMaskGuard.canActivate(category, privType);
} 
getPatientExternalHistory(){
this._patService.getPatientExternalHistory(this.patientId).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
  if(resp && resp?.externalHistory?.length){
    this.generateExternHistList(resp?.externalHistory);
    this.externalHistCount = resp?.externalHistoryCount;
    this.isDataExists = true;
  } else{
    this.isDataExists = false;
    this.externalPatientWJ = new CollectionView(null);
    this.addNewPrescription();
  }
})
}

generateExternHistList(data: any) {
this.externalPatientWJ = new CollectionView(
  data?.map((patRx, i) => {
      const k = {};
      k["Id"] = patRx?.id ? patRx?.id : null;
      k["Rx#"] = patRx?.prescNum ? patRx?.prescNum : null;
      k["Fill Date"] = patRx?.rxFilledDate ? moment(patRx?.rxFilledDate).format(MsgConfig.DATE_FORMAT) : null;
      k["Days Supply"] = patRx?.supplyDays ? patRx.supplyDays : null;
      k["Qty Disp"] = patRx?.dispQty ? (patRx.dispQty).toFixed(3) : "0.000";
      k["Expiration Date"] = patRx?.rxExpirationDate ? moment(patRx?.rxExpirationDate).format(MsgConfig.DATE_FORMAT) : null;
      k["Ordered Date"] = patRx?.rxOrderedDate ? moment(patRx?.rxOrderedDate).format(MsgConfig.DATE_FORMAT) : null;
      k["Drug Name"] = patRx?.drugName?.trim();
      k["Refills Left"] = patRx?.refillsLeft
      k["Active Rx?"] = patRx?.isPrescriptionActive;
      k["Notes"] = patRx?.notes ? patRx?.notes : null;
      k["Source Pharmacy"] = patRx?.sourcePharmacyName ? patRx?.sourcePharmacyName : null;
      k["Added By"] = patRx?.createdBy ? patRx?.createdBy : null;
      k["newRecord"] = patRx?.newRecord ? patRx?.newRecord : false;
      k["editRecord"] = patRx?.editRecord ? patRx?.editRecord : false;
      k["drugNdc"] = patRx?.ndc ? patRx?.ndc : null;
      k["drugId"] = patRx?.drugId ? patRx?.drugId : null;
      k["NPINum"] = patRx?.sourcePharmacyNPI ? patRx?.sourcePharmacyNPI : null;
      const addressParts = [
        patRx?.addressLine1?.trim(),
        patRx?.cityName?.trim(),
        patRx?.stateName?.trim(),
        patRx?.zipCode?.trim()
      ].filter(Boolean).join(', ');
      const hasPhone = !!(patRx?.sourcePharmacyPhoneNumber || patRx?.phone);
      const hasAddress = !!addressParts;
      if (hasPhone && hasAddress) {
        k["sourcePharmacyTitle"] = `${patRx?.phone ? this._commonUtil.getPhoneFormat(patRx?.phone) : this._commonUtil.getPhoneFormat(patRx.sourcePharmacyPhoneNumber)} - ${addressParts}`;
      } else if (hasPhone) {
        k["sourcePharmacyTitle"] = patRx.sourcePharmacyPhoneNumber;
      } else if (hasAddress) {
        k["sourcePharmacyTitle"] = addressParts;
      } else {
        k["sourcePharmacyTitle"] = '';
      }
      return k;
    })
  );
}


closePatHistModel(){
  if(this.isSaveEnabled){
    this.closeAttentionPopup = true;
  } else{
      this.closeExternalHistPopup();
  }
}

cancelPopClose(event){
  this.closeAttentionPopup = false;
  if(event){
    this.closeExternalHistPopup();
  }
}

closeExternalHistPopup(){
    if(this.modelRef){
    this.modelRef.close();
    this.modelRef = null;
    }
    this.SendExternHistCount.emit(this.externalHistCount);
    this.ClosePatHistModel.emit(true);
    this.currentEditItem = null;
    this.drugInformation = null;
}

addNewPrescription() {
  if (!this.externalPatientWJ) {
    this.externalPatientWJ = new CollectionView([]);
  }
  this.isDataExists = true;
  this.iseditRecord = false;
  this.isSaveEnabled = true;
  const technician = this._userService.getToken("TechUserName");
  this.userName = technician || this._userService.getToken("PhUserName");
  const requiredFields = ['Drug Name', 'Fill Date'];
  const hasIncompleteRow = this.externalPatientWJ?.items?.some((item: any) => {
    return requiredFields?.some(field => !item[field] || item[field]?.toString().trim() === '');
  });
  if (hasIncompleteRow) {
    this.isItemAlreadyAdded = false;
    this._cdr.detectChanges();
    this.isItemAlreadyAdded = true;
    return;
  } else {
    this.isItemAlreadyAdded = false;
  }
  const newRow = {
    "Rx#": null,
    "Drug Name": null,
    "Refills Left": null,
    "Expiration Date": null,
    "Ordered Date": null,
    "Fill Date": null,
    "Days Supply": null,
    "Qty Disp": null,
    "Active Rx?": true,
    "Added By": this.userName,
    "Source Pharmacy": null,
    "newRecord": true,
    "editRecord": false
  };
  const sourceArray = this.externalPatientWJ.sourceCollection;
  sourceArray.unshift(newRow);
  this.externalPatientWJ.sourceCollection = [...sourceArray];
  this.externalPatientWJ.refresh();
  this.currentEditItem = newRow;
  this.AddorUpdateExternalHist.emit(this.currentEditItem);
  this.isItemAlreadyAdded = true;
  this.externalPatient.scrollIntoView(0, 0);
}


getEnteredData(event,item,rxID){
if(rxID === "ExpirationDateID"){
  let today = moment().format(MsgConfig.DATE_FORMAT);
  item["Expiration Date"] = event ? event : null;
  item["Active Rx?"] = moment(today, MsgConfig.DATE_FORMAT).isAfter(event) ? false : true;
  const expirationDateFormat = moment(event, MsgConfig.DATE_FORMAT, true);
  const orderedDateFormat = moment(item["Ordered Date"], MsgConfig.DATE_FORMAT, true);
  const fillDateFormat = moment(item["Fill Date"], MsgConfig.DATE_FORMAT, true);
  if (expirationDateFormat?.isValid()) {
    if (orderedDateFormat?.isValid() && expirationDateFormat.isBefore(orderedDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Expt_Date_Less_Than_Ord_Date,
        item,
        "Expiration Date",
        "ExpirationDateID",
        () => { item["Active Rx?"] = true; }
      );
      return;
    }
    if (fillDateFormat?.isValid() && expirationDateFormat.isBefore(fillDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Expt_Date_Less_Than_Fill_Date,
        item,
        "Expiration Date",
        "ExpirationDateID",
        () => { item["Active Rx?"] = true; }
      );
      return;
    }
  }
}
if (rxID === "FillDateID") {
  item["Fill Date"] = event ? event : null;
  const fillDateFormat = moment(event, MsgConfig.DATE_FORMAT, true);
  const orderedDateFormat = moment(item["Ordered Date"], MsgConfig.DATE_FORMAT, true);
  const expirationDateFormat = moment(item["Expiration Date"], MsgConfig.DATE_FORMAT, true);
  // Check if Fill Date is after Expiration Date (check this first)
  if (fillDateFormat?.isValid() && expirationDateFormat?.isValid()) {
    if (fillDateFormat.isAfter(expirationDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Expt_Date_Less_Than_Fill_Date,
        item,
        "Fill Date",
        "FillDateID"
      );
      return;
    }
  }
  // Check if Fill Date is before Ordered Date
  if (orderedDateFormat?.isValid() && fillDateFormat?.isValid()) {
    if (orderedDateFormat.isAfter(fillDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Fill_Date_Less_Than_Ord_Date,
        item,
        "Fill Date",
        "FillDateID",
        () => { this.isFillDateMin = true; }
      );
      return;
    } else {
      this.isFillDateMin = false;
    }
  }
}

if(rxID === "OrderedDateID"){
  item["Ordered Date"] = event ? event : null;
  const orderedDateFormat = moment(event, MsgConfig.DATE_FORMAT, true);
  const expirationDateFormat = moment(item["Expiration Date"], MsgConfig.DATE_FORMAT, true);
  const fillDateFormat = moment(item["Fill Date"], MsgConfig.DATE_FORMAT, true);
  // Check if Ordered Date is after Expiration Date
  if (orderedDateFormat?.isValid() && expirationDateFormat?.isValid()) {
    if (orderedDateFormat.isAfter(expirationDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Expt_Date_Less_Than_Ord_Date,
        item,
        "Ordered Date",
        "OrderedDateID"
      );
      return;
    }
  }
  
  // Check if Ordered Date is after Fill Date
  if (orderedDateFormat?.isValid() && fillDateFormat?.isValid()) {
    if (orderedDateFormat.isAfter(fillDateFormat)) {
      this.showValidationWarning(
        MsgConfig.Fill_Date_Less_Than_Ord_Date,
        item,
        "Ordered Date",
        "OrderedDateID"
      );
      return;
    }
  }
}
if(rxID === "refillsLeftID"){
    item["Refills Left"] = event?.target?.value  ? event?.target?.value : null;
}
if(rxID === "supDaysID"){
  item["Days Supply"] = event?.target?.value ? event?.target?.value : null;
}
if(rxID === "dispQtyID"){
  item["Qty Disp"] = event?.target?.value ? event?.target?.value : null;
}
if(rxID === "rxID"){
  item["Rx#"] =  event?.target?.value  ? event?.target?.value : null;
}
if(rxID === "notesID"){
    item["Notes"] =  event?.target?.value  ? event?.target?.value : null;
}
if(rxID === "drugNameID"){
  item["Drug Name"] = event ? event?.drugname?.trim() + " " + event?.strength?.trim() + " " + event?.drugformname?.trim() : null;
  item["drugNdc"] = event?.ndc ? event?.ndc : null;
  item["drugId"] = event?.id ? event?.id : null;
  if(item["Drug Name"]) this.focusOnNextField('refillsLeftID')
}
this.EmittoSaveExternalHist.emit(this.currentEditItem)
}

focusOnNextField(nxtId) {
  if (document.getElementById(nxtId)) {
      setTimeout(()=>{
          const ele: any = document.getElementById(nxtId);
          if(ele){
              ele.focus();
          }
      }, 0);
  }
}

showValidationWarning(warnMsg: string, item: any, fieldName: string, focusFieldId?: string, additionalReset?: () => void) {
  if (this.isPopupOpen) return;
  this.isPopupOpen = true;
  this.modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {
    backdrop: false,
    keyboard: false,
    windowClass: "large--content",
  });
  this.modelRef.componentInstance.warnMsg = warnMsg;
  this.modelRef.componentInstance.IsHeaderText = "Warning!!";
  this.modelRef.componentInstance.okButton = true;
  this.modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
    if (this.modelRef) {
      this.modelRef.close();
      this.modelRef = null;
    }
    item[fieldName] = null;
    if (additionalReset) {
      additionalReset();
    }
    this.isPopupOpen = false;
    if (focusFieldId) {
      this.focusOnNextField(focusFieldId);
    }
  });
}
getTransferInTooltip(item: any): string {
  let warnMsg;
  if (item?.newRecord) {
    warnMsg = this.msgConfig.Add_Record_First;
  } else if (!this.allowRxTransferIn?.isPrivilege) {
    warnMsg = this.msgConfig.NO_PRIVS_ACCESS;
  } else if (!this.allowRxTransferIn?.serviceAvailability) {
    warnMsg = this.msgConfig.Service_Not_Available;
  } else if (!item?.NPINum) {
    warnMsg = this.msgConfig.Service_Not_Available_Without_NPI;
  }else if (!item['Active Rx?']) {
    warnMsg = this.msgConfig.Inactive_Expired_Rxs_Restrction;
  } else{
     warnMsg = this.msgConfig.Transfer_in_Request;
  }
  return warnMsg;
}
selectDrug(event, item, rxId){
if(rxId === "drugNameID"){
  this.getEnteredData(event, item, rxId);
}
}

selectedPharmDetails(event,item){
  this.sourcePharmacyDetails = event ? event : null;
  const npi = this._userService.getToken("UniquePharmacyId");
  const tenantId = Number(this._userService.getToken("TenantId"));
  let phones: any = [];
  if(event?.Phone) 
    phones.push({Type : 'Phone' , Number: event.Phone});
  if(event?.Fax) 
    phones.push({Type : 'Fax' , Number: event.Fax});
   const payLoad = {
      NCPDPID : event?.NCPDPID,
      Npi : event?.NPINum,
      BusinessName: event?.PharmName ? event?.PharmName : null,
      PhoneNumbers: phones?.length ? phones : [],
      Specialty : null,
      Remarks: event?.Remarks,
      TenantId : tenantId,
      tenantNPI : npi,
      Address : {
        AddressLine1: event?.AddressLine1 ? event.AddressLine1 : null,
        AddressLine2: event?.AddressLine2 ? event.AddressLine2 : null,
        City: event ? event?.CityName : null,
        State:  event ? event?.StateName : null,
        ZipCode: event ? event?.ZipCode : null,
        CountryCode: event ? event?.CountryCode : null
      }
    }
    this.sourcePharmacyNPI = event?.NPINum ? event.NPINum : null;
    this._commonSrv.getOrCreateTransferPharmacy(payLoad).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
      if(res){
        this.sourcePharmacyID = res.Id;
      }
    });
  this.currentEditItem["Phone"] = event?.Phone;
  this.currentEditItem["Source Pharmacy"] = event?.PharmName;
  item.sourcePharmacy = event;
}

saveExternHist(){
const item = this.currentEditItem;
if (!this.currentEditItem){
  this._alertSvc.error("Please add required fields");
} else if (!item?.['Drug Name'] || !item?.['Fill Date']) {
  this._alertSvc.error(!item?.['Drug Name'] ? 'Please select Drug' : !item?.['Fill Date'] ? 'Please select Fill Date' : 'Please add required fields');
  return false;
} else {
    if(item) {
      // Check for duplicate Rx# and Source Pharmacy combination
      var isDuplicate = this.externalPatientWJ?.items?.some((existingItem: any) => {
        if (this.iseditRecord) {
          if (existingItem.Id && item.Id && existingItem.Id === item.Id) {
            return false;
          }
        } else {
          if (existingItem === item) {
            return false;
          }
        }
        
        if (!item["Rx#"] || !item["Source Pharmacy"]) {
          return false;
        }
        
        return existingItem["Rx#"] && existingItem["Source Pharmacy"] &&
               existingItem["Rx#"].toString().trim() === item["Rx#"].toString().trim() &&
               existingItem["Source Pharmacy"].toString().trim() === item["Source Pharmacy"].toString().trim();
      });

      if (isDuplicate) {
        this._alertSvc.error(this.msgConfig.Duplicate_ExternalHistory);
        return false;
      }

      const payload = {
        id: item.Id,
        patientId: this.patientId,
        prescNum: item["Rx#"] ? item["Rx#"] : null,
        drugName: item["Drug Name"] ? item["Drug Name"] : null,
        ndc: item["drugNdc"] ? item["drugNdc"] : null,
        refillsLeft: item["Refills Left"] ? item["Refills Left"] : null,
        rxExpirationDate: item["Expiration Date"] ? moment(item["Expiration Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
        rxOrderedDate: item["Ordered Date"] ? moment(item["Ordered Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
        rxFilledDate: item["Fill Date"] ? moment(item["Fill Date"]).format(MsgConfig.DATE_FORMAT_WITH_EIPHEN) : null,
        supplyDays: item["Days Supply"] ? item["Days Supply"] : null,
        dispQty: item["Qty Disp"] ? item["Qty Disp"] : null,
        sourcePharmacyName: item["Source Pharmacy"] ? item["Source Pharmacy"] : null,
        sourcePharmacyNPI: this.sourcePharmacyNPI ? this.sourcePharmacyNPI: null,
        notes: item["Notes"] ? item["Notes"] : null,
        drugId: item["drugId"] ? item["drugId"] : null,
        transferPharmacyId : this.sourcePharmacyID ? this.sourcePharmacyID : null
      };
      this.selectedRxInfo = payload;
      if(!this.iseditRecord){
          this._patService.addPatientExternalHistory(payload).subscribe((resp)=>{
            if(resp){
              this._alertSvc.success(MsgConfig.SAVE_SUCCESS);
              this.currentEditItem = null;
              this.drugInformation = null;
              this.isItemAlreadyAdded = false;
              this.isSaveEnabled = false;
              this.getPatientExternalHistory();
            } else{
              this._alertSvc.error("Unable to add external history");
            }
        });
      } else{
            this._patService.updatePatientExternalHistory(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((res)=>{
            if(res){
              this._alertSvc.success(MsgConfig.UPDATE_SUCCESS);
              item['editRecord'] = false;
              this.currentEditItem = null;
              this.drugInformation = null;
              this.isItemAlreadyAdded = false;
              this.iseditRecord = false;
              this.isSaveEnabled = false;
              this.getPatientExternalHistory();
            } else {
              this._alertSvc.error("Unable to update external history");
            }
        });
      }
    }
}
}

onFormatItem(e: wjcGrid.FormatItemEventArgs) {
if (e?.panel?.cellType === wjcGrid.CellType.ColumnHeader) {
  const headerText = e.panel.columns[e.col].header;
  if (headerText === 'Drug Name' || headerText === 'Fill Date') {
    e.cell.textContent = ''; 
    const textNode = document.createTextNode(headerText);
    const span = document.createElement('span');
    span.style.color = 'red';
    span.textContent = ' *';
    e.cell.appendChild(textNode);
    e.cell.appendChild(span);
  }
}
}


TransferIn(event){
  if(this.patientId){
    this.getPatientInfoById();
  }
  if(event?.drugId){
  this._commonSrv.getDrugInfo(event?.drugId).subscribe((resp)=>{
    if(resp && resp.Drug){
      this.drugInformation = this.generateGridData(resp.Drug);
    }
  })
  }
  this.openTrnsReqPopup = true;
  if(event?.NPINum || event?.sourcePharmacy?.NPINum){
    this.searchPhamracy(event.sourcePharmacy?.NPINum);
  }
}
async getPatientInfoById() {
  this.rxPatientModel= await this._commonSrv.getRxPatientDetailsById(this.patientId).toPromise();
}
searchPhamracy(event) {
  const modelData = this._commonUtil.getOrganizationRequestForPharmSuggest(event);
  this._eRxService.toGetTranferPharListWithServiceAvail(modelData).subscribe((pharmacies) => {
    if (pharmacies) {
      this.sourcePharmacyDetails = pharmacies?.[0];
    }
  });
}
generateGridData(drug) {
if (drug) {
  let j = {};
  j["drugname"] = drug?.Name;
  j["strength"] = drug?.Strength;
  j["drugformname"] = drug?.DrugFormName;
  j["drugclass"] = drug?.DrugClass;
  j["ndc"] = drug.DrugCode;
  j["isbranded"] = drug?.IsBranded;
  j["qtypack"] = drug?.QtyPack;
  j["manufacturername"] = drug?.ManufactName;
  j["unitpriceawp"] = drug?.UnitPriceAWP;
  j["unitpricecost"] = drug?.UnitPriceCost;
  j["id"] = drug?.Id;
  return j;
}
return null;
}

closeTRxREQPopUpModal(event){
this.openTrnsReqPopup = false;
this.sourcePharmacyDetails = null;
this.sourcePharmacyID = null;
this.sourcePharmacyNPI = null;
}

editExternHist(item) {
  if (this.currentEditItem && this.currentEditItem !== item) {
      this.currentEditItem.editRecord = false;
  }
  item.editRecord = true;
  this.iseditRecord = true;
  this.isSaveEnabled = true;
  item.newRecord = false;
  this.isItemAlreadyAdded = true;
  this.AddorUpdateExternalHist.emit(item);
  this.currentEditItem = item;
}

deleteExternHist(event){
  const modelRefDelete = this._modalService.open(CommonWarnorconfirmPopupComponent, {
    backdrop: false,
    keyboard: false, windowClass: "large--content delete-confirmation-popup"
  });
  modelRefDelete.componentInstance.warnMsg =  MsgConfig.Delete_Confirmation;
  modelRefDelete.componentInstance.yesButton = true;
  modelRefDelete.componentInstance.noButton = true;
  modelRefDelete.componentInstance.IsHeaderText = MsgConfig.Delete_Header_Text;
  modelRefDelete.componentInstance.IsPopUpClosed.subscribe((resp: any) => {
    modelRefDelete.close();
    if (resp) {
      this.proceedToDelete(event);
    } else {
      this.getPatientExternalHistory();
    }
  });
}

proceedToDelete(event){
  const payload = {
    "patientId": this.patientId,
    "externalHistoryId": event?.Id
  }
  this._patService.deletePatientExternalHistory(payload).pipe(takeUntil(this.unsubscribe$)).subscribe((resp)=>{
    if(resp){
      this._alertSvc.success(MsgConfig.DELETE_SUCCESS);
      this.isItemAlreadyAdded = false;
      this.getPatientExternalHistory();
    } else{
      this._alertSvc.error("Unable to delete external history");
    }
})
}

ngOnDestroy() {
this._storageService.getWijmoGridDataInSession(this.wjHeaders,"PatientExternalHistoryWJ")
this.unsubscribe$.next();
this.unsubscribe$.complete();
this._commonUtil.close(this.popupId);
}
}
